import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { addLookupHistoryItemDescription, removeFromLookupHistory } from '../services/lookupHistoryService'
import { CTR_ID_CONTEXT } from '../components/app/LookupContext'
import { getCtrSummary } from '../services/CtrService'
import useNotifications from './useNotifications'

export default function useCtr(cid) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [currentCtr, setCurrentCtr] = useState()

  const fetchCurrentCtr = useCallback(() => {
    const setMetadata = (oldMetadata) => {
      const items = []
      if (oldMetadata.ctrId) {
        items.push({
          ...oldMetadata.ctrId,
          label: t('ctrId', 'CTR ID'),
          showLabel: true,
          field: 'ctrId',
        })
      }
      if (oldMetadata.owsId) {
        items.push({
          ...oldMetadata.owsId,
          label: t('ows.owsId', 'OWS ID'),
          showLabel: true,
          field: 'owsId',
        })
      }
      if (oldMetadata.ctrPerformedDate) {
        items.push({
          ...oldMetadata.ctrPerformedDate,
          label: t('date', 'Date'),
          showLabel: true,
          field: 'ctrPerformedDate',
        })
      }

      return { header: oldMetadata.header, items, badges: null }
    }

    if (cid) {
      setCurrentCtr()
      getCtrSummary(cid)
        .then((results) => {
          const data = results.data
          const person = data.templePlatform ? data.templePlatform.persons.find((p) => p.principal) : null
          if (person?.names?.[0]?.nameForms?.[0]?.fullText) {
            addLookupHistoryItemDescription(CTR_ID_CONTEXT, cid, person.names[0].nameForms[0].fullText)
          }
          data.metadata.header = t('hooks.certifiedTempleRecord', 'Certified Temple Record')
          data.metadata = setMetadata(data.metadata)
          setCurrentCtr(data)
        })
        .catch((err) => {
          if (err.response && err.response.status && err.response.status >= 400 && err.response.status <= 499) {
            removeFromLookupHistory(CTR_ID_CONTEXT, cid)
          }
          error(
            t('hooks.errors.gettingCtr', {
              defaultValue: `Error getting CTR: ${err.message || ''}`,
              message: err.message || '',
            }),
            err
          )
        })
    } else {
      setCurrentCtr(null)
    }
  }, [cid, error, t])

  React.useEffect(() => {
    fetchCurrentCtr()
  }, [fetchCurrentCtr])

  return { currentCtr, fetchCurrentCtr }
}
